<script>
    import {Route, Router} from 'svelte-routing'
    import Home from '../pages/Home.svelte';
    import Lobby from '../pages/Lobby.svelte';
    import Portal from "../pages/admin-pages/Portal.svelte";
    import Admin from "../pages/Admin.svelte";
    import DFGPrizes from "../pages/admin-pages/DFGPrizes.svelte";
    import GameRounds from "../pages/admin-pages/GameRounds.svelte";
    import MagicWallet from "../pages/admin-pages/magic-wallet/MagicWallet.svelte";
    import Users from "../pages/admin-pages/Users.svelte";
    // import BalanceDetails from "../pages/admin-pages/wallet/tabs/BalanceDetails.svelte";

    export let url = '';
</script>

<Router {url}>
    <Route path="/" component="{Home}"/>
    <Route path="lobby" component="{Lobby}"/>
    <Route path="admin" component="{Admin}"/>
    <Route path="portal" component="{Portal}"/>
    <Route path="dfg-prizes" component="{DFGPrizes}"/>
    <Route path="game-rounds" component="{GameRounds}"/>
    <Route path="magic-wallet" component="{MagicWallet}"/>
    <Route path="users" component="{Users}"/>
</Router>
